module.exports = __webpack_public_path__ + "img/poker-h08.3bf5831e.svg";